// Webrtc plugin.
import * as actionTypes from '../actionTypes'

export function devicesChanged (devices) {
  return {
    type: actionTypes.DEVICES_CHANGE,
    payload: devices
  }
}

export function initializeDevice (browserConstraints) {
  return {
    type: actionTypes.INITIALIZE_DEVICES,
    payload: browserConstraints
  }
}

/**
 * The finishing action which follows the INITIALIZE_DEVICES action
 * @param {Object} $0
 * @param {Object} [$0.devices] The device object.
 * @param {Object} [$0.error] An error object. Only present if an error occurred.
 * @returns {Object} A flux standard action representing the INITIALIZE_DEVICES_FINISH action.
 */
export function initializeDeviceFinish ({ devices, error }) {
  return {
    payload: error || devices,
    error: Boolean(error),
    type: actionTypes.INITIALIZE_DEVICES_FINISH
  }
}
